export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";